export function validCookieId(result) {
    if(result && result.ForceRedirect && result.RedirectPageUrl) {
        window.location.href = result.RedirectPageUrl;
    }
    return result;
}

export function getHeaders() {
    return {
        __RequestVerificationToken: $('input[name="__RequestVerificationToken"]').val(),
        CheckoutFlowCookieId: $('input[name="FlowRiderCookieId"]').val()
    };
}
